import { ApiTransport } from './ApiTransport';
import type { AuditLogEntry, AuditLogFilters, PaginatedResult } from './types';

function auditQuery(filters: AuditLogFilters, paginated: boolean): string {
  const params = new URLSearchParams();
  const keys: (keyof AuditLogFilters)[] = [
    'projectKey',
    'action',
    'fromDate',
    'toDate',
    'search',
  ];
  if (paginated) keys.push('page', 'limit');
  for (const key of keys) {
    const value = filters[key];
    if (value) params.set(key, String(value));
  }
  const query = params.toString();
  return query ? `?${query}` : '';
}

export class AuditClient {
  constructor(private readonly transport: ApiTransport) {}

  async getAuditLog(
    filters: AuditLogFilters = {},
  ): Promise<PaginatedResult<AuditLogEntry>> {
    const qs = auditQuery(filters, true);
    const response = await this.transport.request(`/roles/audit${qs}`);
    if (!response.ok) return { data: [], total: 0, page: 1, limit: 50 };
    return response.json();
  }

  async exportAuditLogCsv(filters: AuditLogFilters = {}): Promise<Blob> {
    const qs = auditQuery(filters, false);
    const response = await this.transport.request(`/roles/audit/export${qs}`);
    if (!response.ok) {
      throw new Error('Failed to export audit log');
    }
    return response.blob();
  }
}
